import * as THREE from 'three';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

// layer, collection, element 的父类；
// 用于提取共有操作
class Index extends THREE.Mesh {
  constructor(data) {
    // default invisible
    if (!data) return;
    super(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 }));
    this.props = data.props;
    this.visible = data.props.visible;
    // this.material.depthTes = false;
    this.renderOrder = data.props.zIndex || 0;
    const { position, zIndex } = data.props;
    position && this.position.set(position[0], position[1], position[2]);
    const html = this.getHtmlDom(data);
    // const { left, top } = labelConfig;
    // console.log('position', position, left, top);
    if (html) {
      const label = new CSS2DObject(html);
      // label.position.set(0, 0, position[2]);
      label.position.set(0, 0, position[2]); // 中心点对齐坐标点
      // label.translateX = left || 0;
      label.layers.set(zIndex);
      this.label = label; // 为了渲染CSS2DRender
    }

    const { scale } = data.props;
    scale && this.scale.set(scale[0], scale[1], 1);
  }

  dispose() {
  }

  getLabel() {
    return this.label;
  }

  getHtmlDom(data) {
    const { text = '', className = '', style = {}, htmlDom = '' } = data.props;
    let html = '';
    if (htmlDom) {
      html = htmlDom;
    } else if (text) {
      html = document.createElement('div');
      html.className = className;
      html.textContent = text;
      Object.keys(style).forEach((key) => {
        html.style[key] = style[key];
      });
    }
    return html;
  }

  // meshLine 只和 threejs r124 之前版本兼容，threejs r124 中没有 Object3D.removeFromParent()
  // 因此自己 hack 一下
  // 使用 r129 版本的源码即可
  removeFromParent() {
    const parent = this.parent;
    if (parent !== null) {
      parent.remove(this);
    }
    return this;
  }

  getData() {
    const data = {
      props: this.props,
      children: []
    };
    this.children.forEach((child) => {
      // child.props 不为 null 且 child.getData 存在，才是 layer/collection/element
      if (child.props && child.getData) {
        data.children.push(child.getData());
      }
    });
    return data;
  }

  // 处理以下属性：name, visible, zIndex, position, interactive, scale
  updateProps(key, value) {
    this.props[key] = value;
    switch (key) {
      case 'name':
      case 'interactive':
        break;
      case 'visible':
        this.visible = value;
        break;
      case 'zIndex':
        this.renderOrder = value;
        break;
      case 'position':
        this.position.set(value[0], value[1], value[2]);
        break;
      case 'scale':
        this.scale.set(value[0], value[1], 1);
        break;
    }
  }

  setProps(props) {
    // super
    this.props = props;
    this.visible = props.visible;
    this.renderOrder = props.zIndex || 0;
    const { position } = props;
    position && this.position.set(position[0], position[1], position[2]);
  }

  // Raycaster intersects with invisible objects https://github.com/mrdoob/three.js/issues/14700
  isVisible() {
    let visible = true;
    this.traverseAncestors((parent) => {
      if (!parent.visible) {
        visible = false;
      }
    });
    return visible;
  };
}

export default Index;
